export default __webpack_public_path__ + "static/media/avatar.833b6b5a.png";